import { Component, OnInit, ViewChild, ElementRef, Input, Output, TemplateRef } from '@angular/core';
import { MdSnackBar } from '@angular/material';
//import { BsModalRef } from 'ngx-bootstrap/modal/modal-options.class';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
//import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { ChallanInService, CommonService, SubscribeService, ChallanOutService } from '../../../services/index';
import { ChallanInModel } from '../../../model/index';
import * as _ from 'lodash';
import * as moment from 'moment';

@Component({
    selector: 'add-edit-challanin-tab',
    templateUrl: './addEditChallanIn.component.html',
})
export class AddEditChallanInComponent implements OnInit {
    loadingIndicator: boolean = true;
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }

    public mode: string;
    public list: any[] = [];
    public challanoutsdata: any[] = [];

    isLoadMask: Promise<any>;
    challaninData: ChallanInModel[];
    isLoading: boolean = false;

    @Input() challanindata: ChallanInModel[] = [];
    @Input() challangriddata: ChallanInModel[] = [];
    @Input() testingbilldata: ChallanInModel[] = [];
    @Input() testingtypedata: ChallanInModel[] = [];

    challanlistCtrl: FormControl;
    filteredChallan: Observable<any[]>;
    //halistCtrl: FormControl;
    filteredHa: Observable<any[]>;
    testingbillCtrl: FormControl;
    filteredItems: Observable<any[]>;
    filteredTypes: Observable<any[]>;

    @ViewChild('challanlistAutoComp') challanlistAutoComp;
    //@ViewChild('halistAutoComp') halistAutoComp;
    @ViewChild('testingbillAutoComp') testingbillAutoComp;
    @ViewChild('testingtypeAutoComp') testingtypeAutoComp;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    //@ViewChild('testingamountTemplate') testingamountTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;

    challanList: any[] = [];
    //haList: any[] = [];
    clientList: any[] = [];

    constructor(private challaninService: ChallanInService, private commonService: CommonService, public snackBar: MdSnackBar, public toasterService: ToasterService, public subscribeService: SubscribeService, public challanoutService: ChallanOutService) {

      function hasValidOut(input: FormControl) {
            let challanOutID = input.value;
            let femp = _.find(this.challanList, { 'challan_out_id': challanOutID });
            if(femp)
                return null;
            return { inValidOut: true };
        }
        this.challanlistCtrl = new FormControl('', [
            Validators.required,
            hasValidOut.bind(this)
        ]);
       // this.challanlistCtrl = new FormControl();
        this.filteredChallan = this.challanlistCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterChallan(name) : this.challanList.slice());


        // this.halistCtrl = new FormControl();
        // this.filteredHa = this.halistCtrl.valueChanges
        // 	.startWith(null)
        // 	.map(name => name ? this.filterHa(name) : this.haList.slice());
    }


    reorderable: boolean = true;

    page = {
        limit: 100,
        count: 0,
        offset: 0,
        orderBy: 'challan_in_id',
        orderDir: 'asc'
    };
    columns = [];
    minDate: any;
    challanDetails = [];
    totalDetails = [];
    challanindetail = [];
    ngOnInit(): void {
        //this.loadChallanHaList();
        this.challanlistAutoComp.optionSelected.subscribe(this.onSelectedChallanList.bind(this));

        this.columns = [
            { name: 'SNo', prop: 'sno', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Model Name', prop: 'name', width: 140, minWidth: 140, maxWidth: 140, sortable: false, cellClass: 'cell-left' },
            { name: 'Serial No.', prop: 'serial_no', width: 140, minWidth: 140, maxWidth: 140, sortable: false, cellClass: 'cell-left' },
            { name: 'Quantity', prop: 'quantity', width: 100, minWidth: 100, maxWidth: 100, sortable: false, cellClass: 'cell-right' },
            //{ name: 'ACTION', prop: 'sno', maxWidth: 100, sortable: false, cellTemplate: this.editDeleteTemplate }
        ];

        if (this._params['mode'] == 'Add') {
            this.loadChallanList();
            this.loadAutoNumber();
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());
            this.challanindata['cdate'] = new Date();
        }else{
            this._params['cdate']= new Date(this._params['cdate']);
            this.challanindata=this._params;
        }

    }

    loadAutoNumber(): void {
        let that = this,
            data = {
                account_type: 'challanIn',
                date: moment(this.challanindata['cdate']).format('YYYY-MM-DD')
            };
        this.commonService
            .getAutoNumber(data)
            .then(function(res: any) {
                if (res['success']) {
                    that.challanindata['challan_in_no'] = res['auto_no'];
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops, Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    loadChallanList() {
        let params = {
            challan_out_id : this.challanindata['challan_out_id']
        }
        let that = this;
        this.commonService
            .getChallanOutNoList(params)
            .then(function(res: any) {
                if (res.success) {
                    that.challanList = res.data;
                    that.challanlistCtrl.setValue(that.challanindata['challan_out_id']);
                }
            });
    }

    filterChallan(name: string) {
        name = _.escapeRegExp(name);
        return this.challanList.filter(outDet => (new RegExp(name, 'gi').test(outDet.challan_no)));
    }

    displayChallan(challanOutID: number) {
        if (challanOutID && this.challanList.length > 0) {
            let fchallan = _.find(this.challanList, { 'challan_out_id': challanOutID });
            return fchallan['challan_no'];
        }
        return '';
    }

    onSelectedChallanList(mdCompEvent: any) {
        let challanOutID = mdCompEvent.option.value,
            fchallan = _.find(this.challanList, { 'challan_out_id': challanOutID });

        this.challanindata['date'] = fchallan.co_disp_date;
        this.challanindata['empname'] = fchallan.empname;

        this.getChallanOutModelDetails();
    }

    getChallanOutModelDetails(): void {
        let that = this,
            params = {
                start: `${this.page.offset}`,
                limit: `${this.page.limit}`,
                orderColumn: `model_id`,
                orderBy: 'model_id',
                orderDir: `${this.page.orderDir}`,
                challan_out_id: this.challanindata['challan_out_id']
            };
        this.isLoadMask = this.challanoutService
            .getChallanOutModelDetails(params)
            .then(function(res: any) {
                //if (res.success) {
                that.page.count = res.totCnt;
                that.challanDetails = res.data;
                //}
            });
    }

    //loadChallanHaList() {
    // let that = this;
    // this.commonService
    // 	.getHamodelList()
    // 	.then(function(res: any) {
    // 		that.haList = res;
    // 		that.halistCtrl.setValue(that.challangriddata['model_id']);
    // 		/*if (that.mode == "Edit") {
    // 		  that.brandCtrl.disable();
    // 		  $('#name').focus();
    // 		}*/
    // 	});
    //}

    // filterHa(name: string) {
    // 	name = _.escapeRegExp(name);
    // 	return this.haList.filter(ha => (new RegExp(name, 'gi').test(ha.model_id) || new RegExp(name, 'gi').test(ha.name)));
    // }
    //
    // displayHa(challan_out_id: number) {
    //
    // 	if (challan_out_id && this.haList.length > 0) {
    // 		let fhalist = _.find(this.haList, { 'model_id': challan_out_id });
    // 		this.challangriddata['avail_qty'] = fhalist.avail_qty;
    // 		return fhalist['name'];
    // 	}
    // 	return '';
    // }
    //
    // onSelectedHaList(mdCompEvent: any) {
    // 	let challan_out_id = mdCompEvent.option.value,
    // 		fhalist = _.find(this.haList, { 'model_id': challan_out_id });
    //
    // 	this.challangriddata['model_id'] = fhalist.model_id;
    // 	this.challangriddata['name'] = fhalist.name;
    // }

    setPageData(): void {

        if (this._params != undefined) {
            let mode = this._params['mode'];
            this.challanindata = this._params;
            if (mode == 'View') {
                this.loadChallanList();
                this.getChallanInDetailList();
            }
        }
    }

    getChallanInDetailList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderBy: 'model_id',
            orderDir: `${this.page.orderDir}`,
            challan_in_id: this.challanindata['challan_in_id']
        };

        let that = this;
        this.isLoadMask = this.challaninService
            .getChallanInDetailList(params)
            .then(function(res: any) {

                that.page.count = res.totCnt;
                that.challanDetails = res.data;
            });
    }
    onEnterKeyPressed(nextEl: string): void {
        $('#' + nextEl).focus();
    }

    // onDeleteChallanin(row: any): void {
    //     let that = this;
    //     let mode = this._params['mode'];
    //
    //     if (mode == 'Add') {
    //         this.challanDetails.splice(this.challanDetails.indexOf(row), 1);
    //         this.challangriddata = [];
    //     } else {
    //         let params = {
    //             model_id: row.model_id,
    //             name: row.name,
    //             avail_qty: row.avail_qty,
    //             quantity: row.quantity,
    //             challan_in_id: row.challan_in_id
    //         };
    //         this.challanDetails.splice(this.challanDetails.indexOf(row), 1);
    //     }
    // }

    // addChallanin(): void {
    //
    //     let that = this;
    //
    //
    //     let testing_id = this.challangriddata['model_id'];
    //     if (testing_id != undefined) {
    //
    //         let ftype = _.find(this.challanDetails, { 'model_id': testing_id });
    //
    //         if (ftype && testing_id) {
    //             swal('ALREADY EXISTS', 'Please add another details');
    //             //this.testingtypedata = [];
    //             //that.getTestingbillDetailList();
    //         }
    //         else {
    //             let mode = this._params['mode'];
    //
    //             if (mode == 'Add') {
    //
    //
    //                 let testDet = Object.assign({}, this.challangriddata);
    //                 this.challanDetails.push(testDet);
    //                 this.challangriddata = [];
    //                 that.page.count = this.challanDetails.length;
    //             } else {
    //                 let params = {
    //                     model_id: this.challangriddata['model_id'],
    //                     name: this.challangriddata['name'],
    //                     avail_qty: this.challangriddata['avail_qty'],
    //                     quantity: this.challangriddata['quantity'],
    //                     challan_in_id: this.challanindata['challan_in_id']
    //                 };
    //                 let testDet = Object.assign({}, this.challangriddata);
    //                 this.challanDetails.push(testDet);
    //                 this.challangriddata = [];
    //                 that.page.count = this.challanDetails.length;
    //                 this.challaninService
    //                     .addChallanIn(params)
    //
    //                     .then(function(res: any) {
    //                         that.isLoading = false;
    //                         if (res.success) {
    //
    //                             swal('SUCCESS', res.message, 'success');
    //                             //that.testingbillUpdateEvent.emit();
    //
    //                             that.challangriddata = [];
    //                             that.getChallanInDetailList();
    //
    //                         } else {
    //
    //                             swal('ERROR', res.message, 'error');
    //                         }
    //                     })
    //             }
    //         }
    //     }
    // }

    onSaveChallanin(): void {
        let toast = {
            type: 'warning',
            title: 'WARNING'
        };
        if (_.isEmpty(this.challanindata['challan_out_id'])) {
            toast['body'] = 'Please Select Challan Out No ';
            this.toasterService.pop(toast);
            return;
        }
        let that = this,
            mode = this.challanindata['mode'],
            modelDet = this.challanDetails.length;

        if (modelDet == 0) {
            swal('WARNING', 'No Data Found, <br> Please Add Model Details');
            return;
        }
        let challanInData = moment(this.challanindata['cdate']).format('YYYY-MM-DD'),
            challanindetail = {
                challan_in_id: this.challanindata['challan_in_id'],
                challan_in_no: this.challanindata['challan_in_no'],
                cdate: challanInData,
                challan_out_id: this.challanindata['challan_out_id'],
                date: this.challanindata['date'],
                empname: this.challanindata['empname'],
                challanDetails: JSON.stringify(this.challanDetails),
                mode: mode
            };
        if (mode == 'Add') {
            this.challaninService
                .addUpdateChallanin(challanindetail)
                .then(function(res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        swal('SUCCESS', res.message, 'success');
                        that.subscribeService.subReloadChallanInListGrid();
                        that.challanindata = [];
                        that.challanDetails = [];
                        that.subscribeService.subScribeDeleteActiveTab();
                    } else {
                        swal('ERROR', res.message, 'error');
                    }
                })
                .catch(function(error: any) {
                    that.isLoading = false;
                    let res = JSON.parse(error._body);
                    swal('ERROR', res.message, 'error');
                    //console.log(error);
                });
        } else if (mode == 'Edit') {
            let addding = this.challanDetails.length;
            if (addding != 0) {

                let challanInData = moment(this.challanindata['cdate']).format('YYYY-MM-DD');

                let challanindetail = {
                    challan_in_id: this.challanindata['challan_in_id'],
                    challan_in_no: this.challanindata['challan_in_no'],
                    cdate: challanInData,
                    challan_out_id: this.challanindata['challan_out_id'],
                    date: this.challanindata['date'],
                    empname: this.challanindata['empname'],
                    challanDetails: JSON.stringify(this.challanDetails),
                    mode: this._params['mode']
                };


                this.isLoadMask = this.challaninService
                    .addUpdateChallanin(challanindetail)
                    .then(function(res: any) {
                        that.loadingIndicator = false;
                        that.isLoading = false;
                        if (res.success) {
                            swal('SUCCESS', 'Challan In BIll Added Successfully');
                            //that.reloadChallanInGrid.emit();
                            that.challanindata = [];
                            that.challanDetails = [];
                            that.subscribeService.subScribeDeleteActiveTab();
                        } else {

                            swal('ERROR', res.message, 'error');
                        }

                    })
                    .catch(function(error: any) {
                        that.isLoading = false;
                        let res = JSON.parse(error._body);
                        swal('ERROR', res.message, 'error');
                        //console.log(error);
                    });
            }
            else {
                swal('ERROR', 'Pls Add Testing Bill');
                false;
            }
        }
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/challanIn/addEditChallanIn.component.ts